import React, { useContext, useEffect, useState } from 'react';
import { Button, Grid, Grid2, GridItem, Modal } from '@riac/design-system';
import { Spinner } from '@riac/design-system';
import { AddressBlock } from 'src/pages/AccountPage/components/AddressBlock/AddressBlock';
import { AddressForm } from 'src/pages/AccountPage/components/AddressForm/AddressForm';
import { useFetch } from 'src/lib/FetchContext';
import { IconAdd } from '@riac/design-system';
import { AccountPagesContext } from 'src/lib/AccountPagesContext';
import { AccountPageHeader } from '../components/AccountPageHeader';
import Helmet from 'react-helmet';

interface IAddress {
  Address: string;
  Address2: string;
  AddressID: number;
  AddressType: string;
  AddressTypeID: string;
  City: string;
  CountryName?: string;
  CountryID: string;
  Province: string;
  State: string;
  Zip: string;
}

type TFormAction = 'create' | 'edit' | 'null' | 'done';

interface IAddressType {
  AddressType: string;
  AddressTypeID: number;
}

export interface IAddressForm {
  formData: IAddress;
  addressTypeList: IAddressType[];
  setFormAction(action: TFormAction): void;
  formAction: TFormAction;
}


export const blankAddressForm: IAddress = {
  AddressType: '',
  AddressTypeID: '10',
  CountryID: '236',
  State: '',
  AddressID: null,
  Address: '',
  Address2: '',
  City: '',
  Zip: '',
  Province: '',
};

const AddressBook = () => {
  const { fetch } = useFetch();
  const [addressTypes, setAddressTypes] = useState<IAddressType[]>([]);
  const { getAccount, getAddresses, addresses, account, getStates, getCountries } = useContext(AccountPagesContext);
  const [loading, setLoading] = useState(true);
  const [formAction, setFormAction] = useState<TFormAction>(null);
  const [addressForm, setAddressForm] = useState(blankAddressForm);

  useEffect( () => {
    getAccount();
    getStates();
    getCountries();

    async function getAddressPageData() {
      setLoading(true);
      const addressTypesReq = await fetch('/api/account/address/addressTypeList', { credentials: 'include' });
      const addressTypesRes = await addressTypesReq.json();
      setAddressTypes(addressTypesRes);
      setLoading(false);
    }
    getAddressPageData();
    getAddresses();
  }, []);

  function handleAdd() {
    setFormAction('create');
    setAddressForm(blankAddressForm);
  }

  return (<>
    <AccountPageHeader
      title='Address Book'
      description='Review and edit your addresses'
      slug='/account/address-book'
      titleAddon={<div className='items-stretch flex'>
        <Button
          onPress={() => {
            handleAdd();
          }}
          isDisabled={formAction === 'edit' || formAction === 'create'}
          className='w-full items-center flex gap-2 sm:place-self-start'
        >
          <IconAdd/> Add Address
        </Button>
      </div>}
    />
    <Helmet>
      <title>Address Book | Rock Island Auction</title>
      <meta name='description'
        content={'Review and edit your addresses at Rock Island Auction Company'}/>
    </Helmet>
    {(formAction === 'create' || formAction === 'edit') && (
      <Grid2 className='py-20'>
        <div className={`m-auto max-w-[590px] px-5 py-8 flex-col flex gap-3 border-1 border-surface-darker ${(formAction === 'edit' || formAction === 'create') ? '' : 'hidden'}`}>
          <AddressForm
            formData={addressForm}
            addressTypeList={addressTypes}
            setFormAction={setFormAction}
            formAction={formAction}
          />
        </div>
      </Grid2>
    )}
    <Grid2 className='py-20'>
      <Spinner loading={loading || !account}>
        <div className='flex flex-col gap-3'>
          <div className='flex flex-col sm:flex-row gap-10 flex-wrap pt-3'>
            {addresses?.map((addr) =>
              <AddressBlock
                key={addr.AddressID}
                addr={addr}
                formId={addressForm.AddressID}
                formAction={formAction}
                setFormAction={setFormAction}
                blankForm={blankAddressForm}
                setForm={setAddressForm}
                addressTypeList={addressTypes}
              />
            )}
          </div>
        </div>
      </Spinner>
    </Grid2>
  </>);
};

export default AddressBook;
